import hljs from 'highlight.js/lib/core'
import matlab from 'highlight.js/lib/languages/matlab'
import 'highlight.js/styles/github.css'
import { reportPageView } from './pageview.js'
import { fetchCurrentUser, logout } from './auth-state.js'
import { getLocale, onLocaleChange } from './locale.js'
import { getMessages } from './i18n.js'

// 基于 MATLAB，将注释符改为 # （天元语法）
function tianyuan(hljs) {
  const base = matlab(hljs)
  base.contains = base.contains.map(c => {
    // 替换掉原来的 % 行注释
    if (c.className === 'comment' && c.begin && String(c.begin).includes('%')) {
      return hljs.COMMENT('#', '$')
    }
    return c
  })
  // 兜底：确保 # 注释在最前面
  base.contains.unshift(hljs.COMMENT('#', '$'))
  return base
}

hljs.registerLanguage('tianyuan', tianyuan)
hljs.highlightAll()

// 给每行包裹 <span class="ty-line"> 以触发 CSS 行号计数器
document.querySelectorAll('pre code').forEach(block => {
  const lines = block.innerHTML.split('\n')
  if (lines.at(-1) === '') lines.pop()
  block.innerHTML = lines.map(l => `<span class="ty-line">${l}</span>`).join('')
})

reportPageView('/')

const portalLogoutBtn = document.getElementById('portal-logout-btn')
const portalAccountLink = document.getElementById('portal-nav-account')
const portalUserMenu = document.querySelector('.portal-user-menu')
const portalUserTrigger = document.getElementById('portal-user-trigger')
const portalUserDropdown = document.getElementById('portal-user-dropdown')
const guestNodes = document.querySelectorAll('[data-auth-guest]')
const userNodes = document.querySelectorAll('[data-auth-user]')
const footerText = document.getElementById('portal-footer-text')
let currentPortalUser = null
let portalMenuOpen = false

function t() {
  return getMessages('pages/portal', getLocale())
}

function applyLocalizedText() {
  const text = t()
  document.title = text.title
  document.getElementById('portal-nav-brand-text')?.replaceChildren(document.createTextNode(text.brandName || '天元计算'))
  document.getElementById('portal-hero-brand-text')?.replaceChildren(document.createTextNode(text.brandName || '天元计算'))
  document.getElementById('portal-nav-login')?.replaceChildren(document.createTextNode(text.login))
  document.getElementById('portal-nav-signup')?.replaceChildren(document.createTextNode(text.signup))
  document.getElementById('portal-menu-account')?.replaceChildren(document.createTextNode(text.account))
  document.getElementById('portal-menu-billing')?.replaceChildren(document.createTextNode(text.menuBilling || text.billing))
  document.getElementById('portal-menu-workspace')?.replaceChildren(document.createTextNode(text.menuWorkspace || text.ctaPrimary))
  if (portalAccountLink) {
    const accountLabel = currentPortalUser
      ? (currentPortalUser.display_name || currentPortalUser.username || currentPortalUser.email || text.account)
      : text.account
    portalAccountLink.replaceChildren(document.createTextNode(accountLabel))
    portalAccountLink.title = currentPortalUser ? text.account : ''
  }
  if (portalLogoutBtn) portalLogoutBtn.textContent = text.logout
  document.getElementById('portal-hero-subtitle').textContent = text.heroSubtitle
  document.getElementById('portal-hero-desc').textContent = text.heroDesc
  document.getElementById('portal-cta-primary').textContent = text.ctaPrimary
  document.getElementById('portal-cta-secondary').textContent = text.ctaSecondary
  document.getElementById('portal-demo-label').textContent = text.demoLabel
  document.getElementById('portal-demo-image')?.setAttribute('alt', text.demoAlt)
  document.querySelectorAll('.feature-item').forEach((item, index) => {
    const entry = text.features?.[index] || {}
    const title = entry.title
    const desc = entry.desc
    const titleEl = item.querySelector('.feature-title')
    const descEl = item.querySelector('.feature-desc')
    if (titleEl && title) titleEl.textContent = title
    if (descEl && desc) descEl.textContent = desc
  })
  if (footerText) {
    const link = footerText.querySelector('a')
    footerText.innerHTML = text.footerPrefix
    if (link) footerText.appendChild(link)
  }
}

function setPortalMenuOpen(open) {
  portalMenuOpen = Boolean(open)
  if (portalUserTrigger) {
    portalUserTrigger.setAttribute('aria-expanded', portalMenuOpen ? 'true' : 'false')
  }
  if (portalUserDropdown) {
    portalUserDropdown.hidden = !portalMenuOpen
  }
  portalUserMenu?.classList.toggle('is-open', portalMenuOpen)
}

function setPortalAuthState(user) {
  currentPortalUser = user || null
  const signedIn = Boolean(user)
  guestNodes.forEach((node) => {
    node.hidden = signedIn
  })
  userNodes.forEach((node) => {
    node.hidden = !signedIn
  })
  if (!signedIn) setPortalMenuOpen(false)
  applyLocalizedText()
}

portalLogoutBtn?.addEventListener('click', async () => {
  try {
    await logout()
    window.location.reload()
  } catch {
    // ignore
  }
})

portalUserTrigger?.addEventListener('click', () => {
  setPortalMenuOpen(!portalMenuOpen)
})

document.addEventListener('click', (event) => {
  if (!portalMenuOpen || !portalUserMenu) return
  if (portalUserMenu.contains(event.target)) return
  setPortalMenuOpen(false)
})

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && portalMenuOpen) {
    setPortalMenuOpen(false)
  }
})

setPortalMenuOpen(false)

const bootstrapPortalAuthState = () => {
  fetchCurrentUser()
    .then(setPortalAuthState)
    .catch(() => setPortalAuthState(null))
}

if (typeof window.requestIdleCallback === 'function') {
  window.requestIdleCallback(bootstrapPortalAuthState, { timeout: 1200 })
} else {
  window.setTimeout(bootstrapPortalAuthState, 250)
}

applyLocalizedText()
onLocaleChange(applyLocalizedText)
